export const ENUM_TYPE_REMOVAL = [{ value: 'into_production', label: 'в производство' }, { value: 'customer_return', label: 'возврат давальческих' }]